import { useEffect, useState } from 'react';
import { Button, Grid, TextField, Box } from '@mui/material';
import styles from './visibilityDetails.module.scss'
import Paper from '../../../components/Paper';
import { useSelector } from 'react-redux';
import { bannerLinkSelector } from '../selector';


const VisibilityDetailsV0 = ({ state, setters, handlers, onImageError, validationSetters }) => {
  const { BannerLink : bannerLink } = useSelector(bannerLinkSelector)
  const [jpinValidationError, setJpinValidationError] = useState(false)
  const BANNER_CALLOUT_PLACEHOLDER = 'Text on banner - Holi special, Rice Mela, Dry Fruits Diwali Dhamaka etc'
  const JPINS_TO_SHOW_ON_BANNER_PLACEHOLDER = 'JPIN-1304479702, JPIN-1304545909, JPIN-1304545901'
  const COMMENT_PLACEHOLDER = 'Real-Estate - Home Page (By Default), Category Page, PN etc'
  
  const jpinFormatValidation = (text) => {
    const regex = /^JPIN-\d{10}(,\s?JPIN-\d{10})*$/;
    const isValid = regex.test(text)
    return isValid
  }
  const handleUserInputFormat = (e) => {
    const text = e.target.value;
    if(text === '') {
      validationSetters.jpins.valid(true)
      setJpinValidationError(false)
      return
    } 
    const isValid = jpinFormatValidation(text)
    if(!isValid) {
      validationSetters.jpins.valid(false)
      setJpinValidationError(true)
    } else {
      setJpinValidationError(false)
    }
  }

  const jpinErrorMessage = <span className={styles.errorMessage}>Please enter valid JPIN</span>
  
  /* 
  this useEffect will trigger validate function of createCampaign component, 
  where validate function contains logic to validate all state before permitting
  user to move to next step
  */ 
  useEffect(()=>{
    setters.bannerInput(state.bannerInput)
    setters.jpins(state.jpins)
    setters.url(state.url)
    setters.bannerLink(state.bannerLink)
  },[])
  
  return (
    <Paper heading="Step 4 -  Fill Visibility details ">
      <Grid container className={styles.visibilityDetailsContainer} justifyContent="space-between" alignItems="center">
        <Grid container className={styles.bannerInputContainer}>
          <Grid item xs={5} className={styles.inputItem}>
            <Box className={styles.label} >Banner Callout</Box>
            <TextField fullWidth multiline size='small' type="text" id='banner input' value={state.bannerInput} onChange={handlers.bannerInput} placeholder={BANNER_CALLOUT_PLACEHOLDER}/>
          </Grid>
          <Grid item xs={5} className={styles.inputItem}>
            <Box className={styles.label} >JPINs to display on banner</Box>
            <TextField fullWidth size='small' type="text" id='jpin' value={state.jpins} onChange={handlers.jpins} placeholder={JPINS_TO_SHOW_ON_BANNER_PLACEHOLDER} onKeyUp={handleUserInputFormat} helperText={jpinValidationError ? jpinErrorMessage : null} />
          </Grid>
        </Grid>
        <Grid item xs={12} className={styles.label} >Comment</Grid>
        <Grid item xs={12} >
            <TextField fullWidth multiline size='small' type="text" value={state.comment} onChange={handlers.comment} placeholder={COMMENT_PLACEHOLDER}/>
        </Grid>
        <Box className={styles.bannerLinkContainer}>
          <Grid container item xs={12} justifyContent='space-between'>
            <Grid item xs={12} className={styles.label}>Banner Link <span className={styles.imp}>*</span></Grid>
            <Grid container item xs={5} >
              <Grid item xs={12}>
                <TextField fullWidth multiline size='small' type="text" rows={4} value={state.bannerLink} onChange={handlers.bannerLink} disabled={!bannerLink} placeholder='Add your Link...'/>
              </Grid>
              <Grid item xs={12} marginTop="30px">
                <Button className={`${ styles.btn } ${ state.bannerLink ? styles.containedBtn : "" }`} variant='contained' disabled={!bannerLink} onClick={() => {
                  setters.url(state.bannerLink)
                }}>Preview</Button>
              </Grid>
            </Grid>
            <Grid item xs={6} className={`${styles.alignImgCenter} ${state.url ? '' : styles.noBannerImg}`}>
              { state.url && <img src={state.url}  alt='bannerLink' onError={(e) => {
                setters.url("")
                onImageError(e)
              }} /> }
            </Grid>
          </Grid>
          { !bannerLink && <Box className={styles.bannerVisibilityLayer}></Box> }
        </Box>
      </Grid>
    </Paper>
  );
}

export default VisibilityDetailsV0
